import { c as _c } from "react/compiler-runtime";
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import React from 'react';
import { Error } from '../Error';
import { Width } from '../Width';
export const Email = t0 => {
  const $ = _c(20);
  const {
    name,
    defaultValue,
    errors,
    label,
    register,
    required: requiredFromProps,
    width
  } = t0;
  let t1;
  if ($[0] !== label || $[1] !== name) {
    t1 = <Label htmlFor={name}>{label}</Label>;
    $[0] = label;
    $[1] = name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== name || $[4] !== register || $[5] !== requiredFromProps) {
    t2 = register(name, {
      pattern: /^\S[^\s@]*@\S+$/,
      required: requiredFromProps
    });
    $[3] = name;
    $[4] = register;
    $[5] = requiredFromProps;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== defaultValue || $[8] !== name || $[9] !== t2) {
    t3 = <Input defaultValue={defaultValue} id={name} type="text" {...t2} />;
    $[7] = defaultValue;
    $[8] = name;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== errors || $[12] !== name || $[13] !== requiredFromProps) {
    t4 = requiredFromProps && errors[name] && <Error />;
    $[11] = errors;
    $[12] = name;
    $[13] = requiredFromProps;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t1 || $[16] !== t3 || $[17] !== t4 || $[18] !== width) {
    t5 = <Width width={width}>{t1}{t3}{t4}</Width>;
    $[15] = t1;
    $[16] = t3;
    $[17] = t4;
    $[18] = width;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};